module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp23_4.ee32a282.png";